"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUtcValues = void 0;
const getUtcValues = () => {
    const now = new Date();
    const year = now.getUTCFullYear();
    const month = now.getUTCMonth();
    const date = now.getUTCDate();
    const day = now.getUTCDay();
    const hour = now.getUTCHours();
    const minute = now.getUTCMinutes();
    const second = now.getUTCSeconds();
    const ms = now.getUTCMilliseconds();
    return { year, month, date, day, hour, minute, second, ms };
};
exports.getUtcValues = getUtcValues;
